var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"m-start"},[_c('Title',{staticClass:"m-start_title"}),_c('h2',[_vm._v("A memory game with vue.js")]),_c('Button',{nativeOn:{"click":function($event){return _vm.onClick($event)}}},[_vm._v("play game")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }